import Vue from 'vue'
import Router from 'vue-router'
import { concat } from 'lodash'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading module routes
 * -----------------------------------------------------------------------------------------------------------
 */
import aliasRouter from '@/router/alias'
import homeRouter from '@/components/home/router'
import accountRouter from '@/components/account/router'
import projectRouter from '@/components/project/router'
import previewRouter from '@/components/preview/router'
import agencyRouter from '@/components/agency/router'
import managerRouter from '@/components/manager/router'
import errorRouter from '@/components/error/router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: concat(
    accountRouter,
    projectRouter,
    previewRouter,
    agencyRouter,
    managerRouter,
    aliasRouter,
    homeRouter,
    errorRouter
  )
})



// WEBPACK FOOTER //
// ./src/router/index.js